import { lead, sideCards, edition } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="lead" className="border-b border-foreground-950/10">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-10">
        {/* issue header */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3 md:mb-8">
          <div className="flex items-center gap-3 text-xs text-foreground-600">
            <span className="rounded-full bg-foreground-950 px-3 py-1 font-label font-medium text-background-50">{edition.issue}</span>
            <span className="whitespace-nowrap">{edition.date}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-restart-line" />
            <span className="whitespace-nowrap">滚动收录 · {edition.blurb}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          {/* lead cover */}
          <article className="relative flex flex-col overflow-hidden rounded-lg bg-foreground-950 text-background-100 lg:col-span-2">
            <img
              src={lead.image}
              alt=""
              className="absolute inset-0 h-full w-full object-cover opacity-45"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/10" />
            <div className="relative flex min-h-[360px] flex-1 flex-col justify-between p-5 md:min-h-[440px] md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-flashlight-fill" /> {lead.kicker}
                </span>
                <span className="rounded-full border border-background-100/30 px-3 py-1 text-xs text-background-100">{lead.tag}</span>
              </div>

              <div className="mt-auto pt-10">
                <h1 className="max-w-3xl font-heading text-2xl font-black leading-snug tracking-tight text-background-50 md:text-4xl md:leading-snug">
                  {lead.headline}
                </h1>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
                  {lead.dek}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-100/70">
                  <span className="inline-flex items-center gap-1.5"><i className="ri-user-3-line" /> {lead.author}</span>
                  <span className="inline-flex items-center gap-1.5"><i className="ri-time-line" /> {lead.minutes}</span>
                  <span className="inline-flex items-center gap-1.5"><i className="ri-eye-line" /> 阅读模式可用</span>
                </div>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a href="#deep" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-950 hover:bg-background-200">
                    进入事件还原 <i className="ri-arrow-right-line" />
                  </a>
                  <a href="#faces" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-5 py-2.5 text-sm font-medium text-background-100 hover:border-background-100">
                    查看新涉事者档案
                  </a>
                </div>
              </div>
            </div>
          </article>

          {/* stacked fresh cards */}
          <div className="flex flex-col gap-4">
            {sideCards.map((c) => (
              <article
                key={c.title}
                className="group flex flex-1 cursor-pointer gap-3 rounded-lg border border-foreground-950/10 bg-background-50 p-3 transition-colors hover:border-primary-400/60 md:gap-4 md:p-4"
              >
                <div className="flex min-w-0 flex-1 flex-col justify-between py-0.5">
                  <div>
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-sm bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-800">
                        <i className="ri-file-user-line" /> {c.tag}
                      </span>
                      <span className="whitespace-nowrap text-[11px] text-foreground-500">{c.time}</span>
                    </div>
                    <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-800 md:text-lg">
                      {c.title}
                    </h3>
                    <p className="mt-1.5 hidden text-sm leading-relaxed text-foreground-600 sm:block">{c.snippet}</p>
                  </div>
                </div>
                <div className="h-20 w-20 shrink-0 overflow-hidden rounded-md md:h-24 md:w-24">
                  <img src={c.image} alt="" className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}